import { getEditableField } from '../store/selectors';
import { t } from '../../../../infra/i18n';
export var validateContent = function (params) {
    var store = params.store;
    var state = store.getState();
    var sendSms = getEditableField(state, 'sendSms').value;
    var sendPush = getEditableField(state, 'sendPush').value;
    var sendEmail = getEditableField(state, 'sendEmail').value;
    var smsBody = getEditableField(state, 'smsBody').value;
    var pushBody = getEditableField(state, 'pushBody').value;
    var emailSubject = getEditableField(state, 'emailSubject').value;
    var emailTitle = getEditableField(state, 'emailTitle').value;
    var isValid = true;
    var errors = [];
    if (sendEmail) {
        if (!emailSubject) {
            isValid = false;
            errors.push({ field: 'emailSubject', message: t('engage:validation.subject_required') });
        }
        if (!emailTitle) {
            isValid = false;
            errors.push({ field: 'emailTitle', message: t('engage:validation.title_required') });
        }
    }
    if (sendSms) {
        if (!smsBody && !emailTitle) {
            isValid = false;
            errors.push({ field: 'smsBody', message: t('engage:validation.sms_message_required') });
        }
    }
    if (sendPush) {
        if (!pushBody && !emailTitle) {
            isValid = false;
            errors.push({ field: 'pushBody', message: t('engage:validation.push_message_required') });
        }
    }
    return {
        isValid: isValid,
        errors: errors,
    };
};
